<template>
  <div class="flex justify-center card">
    <button
      type="button"
      @click="toggle"
      aria-haspopup="true"
      aria-controls="overlay_menu"
      class="flex items-center h-10 px-3 py-2 space-x-1 text-sm text-gray-700 duration-300 border border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100"
    >
      <figure class="w-5 h-5">
        <img
          src="@/assets/svg/export.svg"
          alt="export"
          class="object-cover w-full h-full"
        />
      </figure>
      <span>{{ translateText("tableExport.export") }}</span>
      <figure class="w-5 h-5">
        <img
          src="@/assets/svg/chevron-down.svg"
          alt="chevron-down"
          class="object-cover w-full h-full"
        />
      </figure>
    </button>
    <section v-show="menuVisible">
      <Menu
        ref="menu"
        id="overlay_menu"
        :model="filteredItemsMenu"
        :popup="true"
        class="pb-2"
      >
        <template #item="{ item, props }">
          <div
            class="flex items-center p-2 cursor-pointer gap-x-1"
            @click="props.command"
          >
            <span class="text-gray-700" :class="item.icon" />
            <span class="text-sm text-gray-700">{{ item.label }}</span>
          </div>
        </template>
      </Menu>
    </section>
  </div>
</template>

<script>
import { successToast, translateText, lowerCase } from "@/core/helpers/utility";

export default {
  props: {
    fileType: {
      type: String,
      required: false,
      default: "all",
    },
  },
  data() {
    return {
      translateText,
      menuVisible: false,
    };
  },
  computed: {
    items() {
      return [
        {
          label: "Export",
          items: [
            {
              label: translateText("tableExport.exportCSV"),
              icon: "pi pi-file",
              type: "csv",
              command: () => this.exportAsCSV("csv"),
            },
            {
              label: translateText("tableExport.exportExcel"),
              icon: "pi pi-file",
              type: "excel",
              command: () => this.exportAsCSV("excel"),
            },
            {
              label: translateText("tableExport.exportPDF"),
              icon: "pi pi-file",
              type: "pdf",
              command: () => this.exportAsCSV("pdf"),
            },
          ],
        },
      ];
    },

    filteredItemsMenu() {
      if (this.fileType === "all") {
        return [...this.items];
      }

      return this.items.map((group) => ({
        ...group, // Copy all existing properties
        items:
          group.items?.filter(
            (item) => item.type == lowerCase(this.fileType)
          ) || [],
      }));
    },
  },
  methods: {
    toggle(event) {
      if (this.$refs.menu) {
        this.menuVisible = !this.menuVisible;
        this.$refs.menu.toggle(event);
      } else {
        console.warn("Menu reference is not available.");
      }
    },
    exportAsCSV(type) {
      successToast(translateText("payments.downloading"));
      this.$emit("exportAsCSV", type);
    },
  },
};
</script>
